// Relative, not `@/`: scripts/export-ai-search-pages.ts loads this with plain ts-node.
import type { SitemapEntry } from './sitemapCatalog';
import { SITEMAP } from './sitemapCatalog';

/** One page of the portal: the site map's entries for the same path, merged. */
export type CatalogPage = {
  path: string;
  group: string;
  /** Menu-catalog keys that reach it (or UNGATED). */
  keys: string[];
  /** Only for ungated pages; the others take the sidebar's label. */
  label?: string;
  /** What the page is for. */
  blurb: string;
  tabs: string[];
};

const merge = (page: CatalogPage, entry: SitemapEntry): CatalogPage => ({
  ...page,
  keys: [...new Set([...page.keys, ...entry.keys])],
  label: page.label ?? entry.label,
  blurb: page.blurb.includes(entry.blurb) ? page.blurb : `${page.blurb} ${entry.blurb}`,
  tabs: [...new Set([...page.tabs, ...(entry.tabs ?? [])])]
});

/**
 * Every page, once. A path can appear in more than one group of the site map (Home is also the
 * patient list), and the path is what identifies a page to AI Search.
 */
export const PAGE_CATALOG: CatalogPage[] = [
  ...SITEMAP.reduce((pages, group) => {
    group.entries.forEach(entry => {
      const page = pages.get(entry.path) ?? { path: entry.path, group: group.title, keys: [], blurb: entry.blurb, tabs: [] };
      pages.set(entry.path, merge(page, entry));
    });
    return pages;
  }, new Map<string, CatalogPage>()).values()
];

export const catalogPage = (path: unknown): CatalogPage | undefined =>
  typeof path === 'string' ? PAGE_CATALOG.find(page => page.path === path) : undefined;
